<div class="panel preview-object">
    <div class="message">{{getMessage() | trans}}</div>
    <button mat-raised-button color="accent" (click)="download.emit()" *ngIf="download.observers.length" trans>Download</button>
</div>
